export default "__VITE_ASSET__Pgm1V3Lm__"